import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "104",
  height: "24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M103.33 22.538 97.008 8.996h-.76L89.7 22.538l-.08.161h2.697l.029-.066 1.023-2.185.066-.139H99.5l.065.14 1.002 2.184.029.066h2.792l-.074-.16h.015Zm-8.887-4.392.154-.343 1.922-4.283.22.504 1.665 3.771.154.344h-4.122l.007.007ZM86.967 22.7h-2.653V11.276h-4.618v-2.28h11.868v2.28h-4.597v11.422ZM65.481 22.7h-2.653V8.995h2.653V22.7ZM55.294 22.7h-.834L48.468 9.15l-.066-.154h2.806l.03.073 3.486 8.076.226.519.227-.52 3.486-8.075.036-.073h2.675l-.073.161L55.294 22.7ZM47.218 22.7h-.855l-7.813-7.967-.416-.424v8.39h-2.558V8.996h.855l7.783 7.959.424.431v-8.39h2.58V22.7ZM33.12 22.7h-2.652V8.995h2.653V22.7ZM74.097 22.802c-1.527 0-2.952-.49-4.121-1.426-1.652-1.308-2.566-3.274-2.566-5.525 0-3.975 2.902-6.964 6.746-6.964 1.403 0 2.675.402 3.895 1.235l.044.029v.059l-.248 2.513-.022.22-.154-.161c-1.023-1.082-2.127-1.608-3.376-1.608-2.55 0-4.327 1.922-4.327 4.67s1.769 4.575 4.195 4.575c1.389 0 2.631-.6 3.91-1.878l.19-.19-.014.256-.125 2.857v.051l-.036.022a6.911 6.911 0 0 1-3.998 1.272l.007-.008Z",
  fill: "#004E95"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  d: "M21.61 4.794C19.418 1.886 15.946 0 12.03 0H12c-1.915 0-3.72.46-5.328 1.257l8.587 14.836L21.61 4.794Z",
  fill: "#FECB00"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("path", {
  d: "m22.896 6.95-8.192 14.953-.03.05-.028-.05L3.479 3.552A11.957 11.957 0 0 0 0 12c0 6.628 5.372 12 12 12h.022c6.628 0 12-5.372 12-12 0-1.805-.41-3.515-1.125-5.05Z",
  fill: "#004E95"
}, null, -1)
const _hoisted_5 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_5))
}
export default { render: render }